// const styles = {
//   one: { lineHeight: '15px', fontWeight: '400', marginBottom: '10px' },
//   two: { color: 'red', lineHeight: '15px', fontWeight: '400' }
// };

// const sections = [
//   {
//     title: 'Заказы',
//     href: '/app/orders',
//     allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER'],
//     items: [
//       {
//         title: [
//           { title: 'Новые', style: styles.one },
//           { title: 'New', style: styles.two }
//         ],
//         href: '/app/orders/new-orders',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER']
//       },
//       {
//         title: [
//           { title: 'На закупке', style: styles.one },
//           { title: 'On purchase', style: styles.two }
//         ],
//         href: '/app/orders/waiting_to_be_purchased',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER']
//       },
//       {
//         title: [
//           { title: 'Выкуплены', style: styles.one },
//           { title: 'Redeemed', style: styles.two }
//         ],
//         href: '/app/orders/redeemed',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER']
//       },
//       {
//         title: [
//           { title: 'На согласовании', style: styles.one },
//           { title: 'To be agreed', style: styles.two }
//         ],
//         href: '/app/orders/pending_price_confirmation',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER']
//       },
//       {
//         title: [
//           { title: 'Перенесен в товары', style: styles.one },
//           { title: 'Moved to products', style: styles.two }
//         ],
//         href: '/app/orders/moved_to_goods',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER']
//       },
//       {
//         title: [
//           { title: 'Отменен', style: styles.one },
//           { title: 'Canceled', style: styles.two }
//         ],
//         href: '/app/orders/canceled',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER']
//       }
//     ]
//   },
//   {
//     title: 'Груз / 货物',
//     href: '/app/cargo',
//     allowedRoles: [
//       'ADMINISTRATOR',
//       'SUPPORT_DIRECTOR',
//       'ACCEPTOR_CARGO',
//       'PACKER'
//     ],
//     items: [
//       {
//         title: 'Получение груза от курьеров / 从快递公司接收货物',
//         href: '/app/cargo/courier-accept',
//         allowedRoles: [
//           'ADMINISTRATOR',
//           'SUPPORT_DIRECTOR',
//           'ACCEPTOR_CARGO',
//           'PACKER'
//         ]
//       },
//       {
//         title: 'Прием груза',
//         href: '/app/cargo/accept',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'ACCEPTOR_CARGO']
//       },
//       {
//         title: 'ГГ Ожидается',
//         href: '/app/cargo/expected',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Добавить груз',
//         href: '/app/cargo/create',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Создание посылок',
//         href: '/app/cargo/create-parcel',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Возвраты',
//         href: '/app/cargo/returns',
//         allowedRoles: ['ADMINISTRATOR']
//       }
//     ]
//   },
//   {
//     title: 'Посылки / 包裹',
//     href: '/app/parcels/complectation',
//     allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'PACKER'],
//     items: [
//       {
//         title: 'На комплектации / 配成全套',
//         href: '/app/parcels/complectation',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'PACKER']
//       },
//       {
//         title: 'На взвешивании / 称重',
//         href: '/app/parcels/weight',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'PACKER']
//       },
//       {
//         title: 'Посылки для оплаты',
//         href: '/app/parcels/pay',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Посылки для отправки',
//         href: '/app/parcels/send',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Реестры отправок',
//         href: '/app/reference/dispatch-register',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Посылки на доставке в РФ',
//         href: '/app/distribution/distribution-rf',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Посылки на таможне в РФ',
//         href: '/app/customs/customs-rf',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       }
//       // {
//       //   title: 'На таможне',
//       //   href: '/app/parcels/customs',
//       //   allowedRoles: ['ADMINISTRATOR']
//       // },
//       // {
//       //   title: 'На доставке',
//       //   href: '/app/parcels/delivery',
//       //   allowedRoles: ['ADMINISTRATOR']
//       // },
//     ]
//   },
//   {
//     title: 'Справочники',
//     href: '/app/reference',
//     allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'ACCEPTOR_CARGO'],
//     items: [
//       {
//         title: 'Заказы ',
//         href: '/app/reference/orders',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Грузы',
//         href: '/app/reference/cargo',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'ACCEPTOR_CARGO']
//       },
//       {
//         title: 'Сверка для реестра',
//         href: '/app/reference/register',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Посылки ',
//         href: '/app/reference/parcels',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Адреса',
//         href: '/app/reference/addresses',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Клиенты',
//         href: '/app/reference/clients',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Паспорта',
//         href: '/app/reference/passport-verification',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Сотрудники',
//         href: '/app/reference/staff',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Потеряшки',
//         href: '/app/reference/lost',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Сканирование груза (Курьеры)',
//         href: '/app/reference/cargo-scan',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Сканирование груза на устройстве',
//         href: '/app/reference/cargo-scan-device',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Категория грузов',
//         href: '/app/reference/cargo-categories',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Категории опасности груза',
//         href: '/app/reference/danger-categories',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Тип транспорта доставки',
//         href: '/app/reference/transport-type',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Управление складом',
//         href: '/app/reference/warehouse-managment',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Настройки стран',
//         href: '/app/reference/country-settings',
//         allowedRoles: ['ADMINISTRATOR']
//       }
//     ]
//   },
//   {
//     title: 'Финансы',
//     href: '/app/finances',
//     allowedRoles: ['ADMINISTRATOR'],
//     items: [
//       {
//         title: 'Курсы валют',
//         href: '/app/finances/rate',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Транзакции',
//         href: '/app/finances/transactions',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       },
//       {
//         title: 'Счета',
//         href: '/app/finances/accounts',
//         allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR']
//       }
//     ]
//   },
//   {
//     title: 'Тарифы',
//     href: '/app/tariffs',
//     allowedRoles: ['ADMINISTRATOR'],
//     items: [
//       {
//         title: 'Дополнительные услуги',
//         href: '/app/tariffs/additional',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Группы тарифов',
//         href: '/app/tariffs/tariff-groups',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Тарифы доставки',
//         href: '/app/tariffs/shipping',
//         allowedRoles: ['ADMINISTRATOR']
//       },
//       {
//         title: 'Тариф последней мили',
//         href: '/app/tariffs/last-mile',
//         allowedRoles: ['ADMINISTRATOR']
//       }
//     ]
//   }
// ];

// export default sections;

import {
  // BarChart2 as BarChartIcon,
  // Codepen,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Package as PackageIcon,
  ShoppingBag as ShoppingBagIcon,
  Trash2 as Trash2Icon,
  Truck as TruckIcon,
} from 'react-feather'
import { CARGO_URLS, ORDER_URLS } from 'src/constants'
import PvzIcon from './PvzIcon'

// const styles = {
//   one: { lineHeight: '15px', fontWeight: '400', marginBottom: '10px' },
//   two: { color: 'red', lineHeight: '15px', fontWeight: '400' }
// };

const sections = [
  {
    title: 'Заказы / 订单管理',
    href: '/app/orders',
    icon: ShoppingBagIcon,
    allowedRoles: [
      'ADMINISTRATOR',
      'BUYERS_DIRECTOR',
      'SUPPORT_DIRECTOR',
      'REDEEMER',
      'ACCEPTOR_CARGO_ADMIN',
      'WAREHOUSE_DIRECTOR',
    ],
    items: [
      {
        title: 'Новые',
        titleEN: '新收订单',
        href: '/app/orders/new-orders',
        allowedRoles: [
          'ADMINISTRATOR',
          'BUYERS_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'REDEEMER',
          'ACCEPTOR_CARGO_ADMIN',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      {
        title: 'На закупке',
        titleEN: '采购订单',
        href: '/app/orders/waiting_to_be_purchased',
        allowedRoles: [
          'ADMINISTRATOR',
          'BUYERS_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'REDEEMER',
          'ACCEPTOR_CARGO_ADMIN',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      {
        title: 'Выкуплены',
        titleEN: '已经购买',
        href: '/app/orders/redeemed',
        allowedRoles: [
          'ADMINISTRATOR',
          'BUYERS_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'REDEEMER',
          'ACCEPTOR_CARGO_ADMIN',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      {
        title: 'На согласовании',
        titleEN: '有待商定',
        href: '/app/orders/pending_price_confirmation',
        allowedRoles: [
          'ADMINISTRATOR',
          'BUYERS_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'REDEEMER',
          'ACCEPTOR_CARGO_ADMIN',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      {
        title: 'Перенесен в товары',
        titleEN: '订单有追踪号码了',
        href: '/app/orders/moved_to_goods',
        allowedRoles: [
          'ADMINISTRATOR',
          'BUYERS_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'REDEEMER',
          'ACCEPTOR_CARGO_ADMIN',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      {
        title: 'Товары > 5 дней',
        titleEN: '',
        href: '/app/orders/goods_more_then_five_day',
        allowedRoles: [
          'ADMINISTRATOR',
          'BUYERS_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'REDEEMER',
          'ACCEPTOR_CARGO_ADMIN',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      {
        title: 'Отменен',
        titleEN: '取消订单了',
        href: '/app/orders/canceled',
        allowedRoles: [
          'ADMINISTRATOR',
          'BUYERS_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'REDEEMER',
          'ACCEPTOR_CARGO_ADMIN',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      // {
      //   title: 'Ожидает оплату на DobroPoizon',
      //   titleEN: '等待 DobroPoizon 付款',
      //   href: '/app/orders/waiting_for_payment_on_dobroPoizon',
      //   allowedRoles: [
      //     'ADMINISTRATOR',
      //     'SUPPORT_DIRECTOR',
      //     'REDEEMER',
      //     'ACCEPTOR_CARGO_ADMIN',
      //   ],
      // },
    ],
  },
  {
    title: 'Груз / 货物',
    href: '/app/cargo',
    icon: TruckIcon,
    allowedRoles: [
      'ADMINISTRATOR',
      'BUYERS_DIRECTOR',
      'SUPPORT_DIRECTOR',
      'ACCEPTOR_CARGO_ADMIN',
      'ACCEPTOR_CARGO',
      'COURIER',
      'WAREHOUSE_DIRECTOR',
      'SUPPORT_OPERATOR',
    ],
    items: [
      {
        title: 'Получение груза от курьеров / 从快递公司接收货物',
        href: '/app/cargo/courier-accept',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'ACCEPTOR_CARGO_ADMIN',
          'ACCEPTOR_CARGO',
          'COURIER',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_OPERATOR',
        ],
      },
      /*{
        title: 'Груз от курьера (МОБ)',
        href: '/app/cargo/courier-accept/mobile',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'ACCEPTOR_CARGO',
          'COURIER',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_OPERATOR',
          'ACCEPTOR_CARGO_ADMIN',
        ],
      },*/
      {
        title: 'Груз от курьера (new)',
        href: '/app/cargo/courier-accept/mobile-redesign',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'ACCEPTOR_CARGO',
          'COURIER',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_OPERATOR',
          'ACCEPTOR_CARGO_ADMIN',
        ],
      },
      {
        title: 'Прием груза',
        href: '/app/cargo/accept',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'ACCEPTOR_CARGO',
          'SUPPORT_OPERATOR',
          'ACCEPTOR_CARGO_ADMIN',
        ],
      },
      // {
      //   title: 'ГГ Ожидается',
      //   href: '/app/cargo/expected',
      //   allowedRoles: ['ADMINISTRATOR', 'SUPPORT_OPERATOR'],
      // },
      {
        title: 'Добавить груз',
        href: '/app/cargo/create',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'SUPPORT_OPERATOR'],
      },
      // {
      //   title: 'Создание посылок',
      //   href: '/app/cargo/create-parcel',
      //   allowedRoles: ['ADMINISTRATOR', 'SUPPORT_OPERATOR'],
      // },
      {
        title: 'Возвраты',
        href: `/app/cargo/returns/${CARGO_URLS.CARGO_RETURNS_BY_CODE}`,
        allowedRoles: [
          'ADMINISTRATOR',
          'BUYERS_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'WAREHOUSE_DIRECTOR',
          'ACCEPTOR_CARGO_ADMIN',
          'ACCEPTOR_CARGO',
          'SUPPORT_OPERATOR',
        ],
        items: [
          {
            id: '1',
            title: 'По коду',
            href: `/app/cargo/returns/${CARGO_URLS.CARGO_RETURNS_BY_CODE}`,
            allowedRoles: [
              'ADMINISTRATOR',
              'BUYERS_DIRECTOR',
              'SUPPORT_DIRECTOR',
              'WAREHOUSE_DIRECTOR',
              'ACCEPTOR_CARGO_ADMIN',
              'ACCEPTOR_CARGO',
              'SUPPORT_OPERATOR',
            ],
          },
          {
            id: '2',
            title: 'По адресу',
            href: `/app/cargo/returns/${CARGO_URLS.CARGO_RETURNS_BY_ADDRESS}`,
            allowedRoles: [
              'ADMINISTRATOR',
              'BUYERS_DIRECTOR',
              'SUPPORT_DIRECTOR',
              'WAREHOUSE_DIRECTOR',
              'ACCEPTOR_CARGO_ADMIN',
              'ACCEPTOR_CARGO',
              'SUPPORT_OPERATOR',
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'ПВЗ / 自提点',
    href: '/app/pvz',
    icon: PvzIcon,
    allowedRoles: ['PVZ', 'ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
    items: [
      {
        title: 'Прием/ 收货',
        href: '/app/pvz/accept',
        allowedRoles: ['PVZ', 'ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      },
      {
        title: 'Выдача/ 取货',
        href: '/app/pvz/issue',
        allowedRoles: ['PVZ', 'ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      },
      {
        title: 'История посылок / 包裹历史',
        href: '/app/pvz/parcel-history',
        allowedRoles: ['PVZ', 'ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      },
      {
        title: 'Баланс ПВЗ / 自提点余额',
        href: '/app/pvz/balance',
        allowedRoles: ['PVZ', 'ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      },
    ],
  },
  {
    title: 'Посылки / 包裹',
    href: '/app/parcels',
    icon: PackageIcon,
    allowedRoles: [
      'ADMINISTRATOR',
      'WAREHOUSE_DIRECTOR',
      'SUPPORT_DIRECTOR',
      'PACKER',
      'SUPPORT_OPERATOR',
    ],
    items: [
      {
        title: 'На комплектации / 配成全套',
        href: '/app/parcels/complectation',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'PACKER',
          'SUPPORT_OPERATOR',
        ],
      },
      {
        title: 'На взвешивании / 称重',
        href: '/app/parcels/weight',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'PACKER',
        ],
      },
      {
        title: 'Посылки для оплаты / 待发运包裹',
        href: '/app/parcels/pay',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
        ],
      },
      {
        title: 'Посылки для отправки / 待发货',
        href: '/app/parcels/send',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
        ],
      },
      {
        title: 'Мешки на складе / 仓库袋包',
        href: '/app/parcels/bags',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_OPERATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'PACKER',
        ],
      },
      {
        title: 'Проверка оплаты / 请检查包裹是否已经付款',
        href: '/app/parcels/verification',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
        ],
      },
      {
        title: 'Смена данных посылки / 修改包裹信息',
        href: '/app/parcels/change-parcel-data',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'PACKER',
          'SUPPORT_OPERATOR',
        ],
      },
      {
        title: 'Реестры отправок',
        href: '/app/parcels/dispatch-register-view',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_DIRECTOR',
          'PACKER',
          'SUPPORT_OPERATOR',
        ],
      },
      // {
      //   title: 'Посылки на доставке в РФ / 俄罗斯境内配送中包裹',
      //   href: '/app/distribution/distribution-rf',
      //   allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      // },
      // {
      //   title: 'Посылки на таможне в РФ / 俄罗斯海关清关中包裹',
      //   href: '/app/customs/customs-rf',
      //   allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      // },
      {
        title: 'Проверка данных реестры / 运单数据核对',
        titleEN: '新收订单',
        href: `/app/parcels/${ORDER_URLS.CHECKING_REGISTRY_DATA}`,
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER'],
        items: [
          {
            id: '1',
            title: 'Таблица посылок',
            href: `/app/parcels/${ORDER_URLS.CHECKING_REGISTRY_DATA_TABLE}`,
            allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER'],
          },
          {
            id: '2',
            title: 'Проверка посылки',
            href: `/app/parcels/${ORDER_URLS.CHECKING_REGISTRY_DATA_CHECK}`,
            allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER'],
          },
          {
            id: '3',
            title: 'Таблица шипментов',
            href: `/app/parcels/shipments/${ORDER_URLS.CHECKING_REGISTRY_DATA_TABLE_SHIPMENT}`,
            allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER'],
          },
          {
            id: '4',
            title: 'Проверка шипмента',
            href: `/app/parcels/shipments/${ORDER_URLS.CHECKING_REGISTRY_DATA_SHIPMENT}`,
            allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'REDEEMER'],
          },
        ],
      },
      // {
      //   title: 'На таможне',
      //   href: '/app/parcels/customs',
      //   allowedRoles: ['ADMINISTRATOR']
      // },
      // {
      //   title: 'На доставке',
      //   href: '/app/parcels/delivery',
      //   allowedRoles: ['ADMINISTRATOR']
      // },
    ],
  },
  // {
  //   title: 'Карго',
  //   href: '/app/cargo-package',
  //   icon: Codepen,
  //   allowedRoles: [
  //     'ADMINISTRATOR',
  //     'WAREHOUSE_DIRECTOR',
  //     'SUPPORT_DIRECTOR',
  //     'PACKER',
  //     'SUPPORT_OPERATOR',
  //     'CARGO_USER',
  //   ],
  //   items: [
  //     {
  //       title: 'На комплектации / 配货中',
  //       href: '/app/cargo-package/cargos-on-assembly',
  //       allowedRoles: [
  //         'ADMINISTRATOR',
  //         'WAREHOUSE_DIRECTOR',
  //         'SUPPORT_DIRECTOR',
  //         'PACKER',
  //         'SUPPORT_OPERATOR',
  //         'CARGO_USER',
  //       ],
  //     },
  //     {
  //       title: 'На взвешивании / 称重中',
  //       href: '/app/cargo-package/cargos-weigh-in',
  //       allowedRoles: [
  //         'ADMINISTRATOR',
  //         'WAREHOUSE_DIRECTOR',
  //         'SUPPORT_DIRECTOR',
  //         'PACKER',
  //         'SUPPORT_OPERATOR',
  //         'CARGO_USER',
  //       ],
  //     },
  //     {
  //       title: 'Карго для отправки / 待发运',
  //       href: '/app/cargo-package/cargos-for-shipment',
  //       allowedRoles: [
  //         'ADMINISTRATOR',
  //         'WAREHOUSE_DIRECTOR',
  //         'SUPPORT_DIRECTOR',
  //         'PACKER',
  //         'SUPPORT_OPERATOR',
  //         'CARGO_USER',
  //       ],
  //     },
  //     {
  //       title: 'Реестр партий',
  //       href: '/app/cargo-package/cargos-registry',
  //       allowedRoles: [
  //         'ADMINISTRATOR',
  //         'WAREHOUSE_DIRECTOR',
  //         'SUPPORT_DIRECTOR',
  //         'PACKER',
  //         'SUPPORT_OPERATOR',
  //         'CARGO_USER',
  //       ],
  //     },
  //   ],
  // },
  {
    title: 'Справочники / 参考目录',
    href: '/app/reference',
    icon: FileTextIcon,
    allowedRoles: [
      'ADMINISTRATOR',
      'SUPPORT_DIRECTOR',
      'ACCEPTOR_CARGO_ADMIN',
      'ACCEPTOR_CARGO',
      'PACKER',
      'REDEEMER',
      'SUPPORT_OPERATOR',
      'WAREHOUSE_DIRECTOR',
      'CARGO_USER',
    ],
    items: [
      {
        title: 'Заказы / 订单管理',
        href: '/app/reference/orders',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'SUPPORT_OPERATOR',
          'ACCEPTOR_CARGO_ADMIN',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      {
        title: 'Грузы',
        href: '/app/reference/cargo',
        allowedRoles: [
          'ADMINISTRATOR',
          'REDEEMER',
          'SUPPORT_DIRECTOR',
          'ACCEPTOR_CARGO_ADMIN',
          'ACCEPTOR_CARGO',
          'SUPPORT_OPERATOR',
          'WAREHOUSE_DIRECTOR',
          'CARGO_USER',
        ],
      },
      {
        title: 'Задачи',
        href: '/app/reference/tasks',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'ACCEPTOR_CARGO_ADMIN',
          'ACCEPTOR_CARGO',
          'PACKER',
          'REDEEMER',
          'WAREHOUSE_DIRECTOR',
        ],
      },
      // {
      //   title: 'Задачи / Утилизировать',
      //   href: '/app/reference/dispose/tasks',
      //   allowedRoles: [
      //     'ADMINISTRATOR',
      //     'SUPPORT_DIRECTOR',
      //     'ACCEPTOR_CARGO',
      //     'PACKER',
      //     'REDEEMER',
      //     'WAREHOUSE_DIRECTOR',
      //     'ACCEPTOR_CARGO_ADMIN',
      //   ],
      // },
      // {
      //   title: 'Сверка для реестра',
      //   href: '/app/reference/register',
      //   allowedRoles: ['ADMINISTRATOR'],
      // },
      {
        title: 'Посылки',
        href: '/app/reference/parcels',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'PACKER',
          'SUPPORT_OPERATOR',
          'WAREHOUSE_DIRECTOR',
          'CARGO_USER',
        ],
      },
      // {
      //   title: 'Карго',
      //   href: '/app/reference/cargo-package-all',
      //   allowedRoles: [
      //     'ADMINISTRATOR',
      //     'SUPPORT_DIRECTOR',
      //     'PACKER',
      //     'SUPPORT_OPERATOR',
      //     'WAREHOUSE_DIRECTOR',
      //     'CARGO_USER',
      //   ],
      // },
      {
        title: 'Шипменты',
        href: '/app/reference/shipments',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'PACKER',
          'SUPPORT_OPERATOR',
          'WAREHOUSE_DIRECTOR',
          'CARGO_USER',
        ],
      },
      // {
      //   title: 'Адреса',
      //   href: '/app/reference/addresses',
      //   allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      // },
      {
        title: 'Клиенты',
        href: '/app/reference/clients',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      },
      {
        title: 'Паспорта',
        href: '/app/reference/passport-verification',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'SUPPORT_OPERATOR'],
      },
      {
        title: 'Паспорта (шипменты)',
        href: '/app/reference/passports-with-partner',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'SUPPORT_OPERATOR'],
      },
      {
        title: 'Сотрудники',
        href: '/app/reference/staff',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      },
      {
        title: 'Потеряшки',
        href: '/app/reference/lost',
        allowedRoles: [
          'ADMINISTRATOR',
          'WAREHOUSE_DIRECTOR',
          'SUPPORT_OPERATOR',
          'ACCEPTOR_CARGO_ADMIN',
          'ACCEPTOR_CARGO',
          'SUPPORT_DIRECTOR',
        ],
      },
      // {
      //   title: 'Сканирование груза (Курьеры)',
      //   href: '/app/reference/cargo-scan',
      //   allowedRoles: ['ADMINISTRATOR', 'SUPPORT_OPERATOR'],
      // },
      {
        title: 'Сканирование груза на устройстве',
        href: '/app/reference/cargo-scan-device',
        allowedRoles: ['ADMINISTRATOR'],
      },
      // {
      //   title: 'Категория грузов',
      //   href: '/app/reference/cargo-categories',
      //   allowedRoles: ['ADMINISTRATOR'],
      // },
      // {
      //   title: 'Категории опасности груза',
      //   href: '/app/reference/danger-categories',
      //   allowedRoles: ['ADMINISTRATOR'],
      // },
      // {
      //   title: 'Тип транспорта доставки',
      //   href: '/app/reference/transport-type',
      //   allowedRoles: ['ADMINISTRATOR'],
      // },
      {
        title: 'Управление складом',
        href: '/app/reference/warehouse-managment',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      },
      {
        title: 'Сканирование ПВЗ',
        href: '/app/reference/pvz-scan',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR'],
      },
      // {
      //   title: 'Настройки стран',
      //   href: '/app/reference/country-settings',
      //   allowedRoles: ['ADMINISTRATOR'],
      // },
    ],
  },
  {
    title: 'Финансы / 财务',
    href: '/app/finances',
    icon: DollarSignIcon,
    allowedRoles: [
      'ADMINISTRATOR',
      'SUPPORT_OPERATOR',
      'SUPPORT_DIRECTOR',
      'BUYERS_DIRECTOR',
    ],
    items: [
      {
        title: 'Курсы валют',
        href: '/app/finances/rate',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'BUYERS_DIRECTOR'],
      },
      {
        title: 'Транзакции',
        href: '/app/finances/transactions',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_OPERATOR',
          'SUPPORT_DIRECTOR',
          'BUYERS_DIRECTOR',
        ],
      },
      {
        title: 'Счета',
        href: '/app/finances/accounts',
        allowedRoles: ['ADMINISTRATOR', 'SUPPORT_DIRECTOR', 'BUYERS_DIRECTOR'],
      },
    ],
  },
  {
    title: 'Задачи / Утилизировать',
    href: '/app/dispose',
    icon: Trash2Icon,
    allowedRoles: [
      'ADMINISTRATOR',
      'SUPPORT_DIRECTOR',
      'ACCEPTOR_CARGO',
      'PACKER',
      'REDEEMER',
      'WAREHOUSE_DIRECTOR',
      'ACCEPTOR_CARGO_ADMIN',
    ],
    items: [
      {
        title: 'Утилизировать / Товары',
        href: '/app/dispose/tasks',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'ACCEPTOR_CARGO',
          'PACKER',
          'REDEEMER',
          'WAREHOUSE_DIRECTOR',
          'ACCEPTOR_CARGO_ADMIN',
        ],
      },
      {
        title: 'Утилизировать / Посылки',
        href: '/app/dispose/parcles',
        allowedRoles: [
          'ADMINISTRATOR',
          'SUPPORT_DIRECTOR',
          'ACCEPTOR_CARGO',
          'PACKER',
          'REDEEMER',
          'WAREHOUSE_DIRECTOR',
          'ACCEPTOR_CARGO_ADMIN',
        ],
      },
    ],
  },
  // {
  //   title: 'Тарифы / 运费标准',
  //   href: '/app/tariffs',
  //   icon: BarChartIcon,
  //   allowedRoles: ['ADMINISTRATOR'],
  //   items: [
  //     // {
  //     //   title: 'Дополнительные услуги',
  //     //   href: '/app/tariffs/additional',
  //     //   allowedRoles: ['ADMINISTRATOR'],
  //     // },
  //     {
  //       title: 'Группы тарифов',
  //       href: '/app/tariffs/tariff-groups',
  //       allowedRoles: ['ADMINISTRATOR'],
  //     },
  //     {
  //       title: 'Тарифы доставки',
  //       href: '/app/tariffs/shipping',
  //       allowedRoles: ['ADMINISTRATOR'],
  //     },
  //     {
  //       title: 'Тариф последней мили',
  //       href: '/app/tariffs/last-mile',
  //       allowedRoles: ['ADMINISTRATOR'],
  //     },
  //   ],
  // },
]

export default sections
